import { Component } from '@angular/core';

@Component({
    selector: 'app-timeline-ul',
    imports: [],
    template: '<ul class="timeline"><ng-content></ng-content></ul>',
    styleUrls: ['./timeline-ul.component.scss']
})
export class TimelineUlComponent {}
